import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { useTheme } from '../contexts/ThemeContext';

const BottomNav = ({ currentPage, darkTheme }) => {
  const { isLightMode } = useTheme();
  const navigate = useNavigate();

  const navItems = [
    { id: 'home', icon: 'solar:home-2-linear', activeIcon: 'solar:home-2-bold', path: '/dashboard' },
    { id: 'plan', icon: 'solar:clipboard-list-linear', activeIcon: 'solar:clipboard-list-bold', path: '/plan' },
    { id: 'achievements', icon: 'solar:cup-star-linear', activeIcon: 'solar:cup-star-bold', path: '/achievements' },
    { id: 'stats', icon: 'solar:chart-2-linear', activeIcon: 'solar:chart-2-bold', path: '/stats' },
  ];

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 backdrop-blur-xl border-t flex items-center justify-around z-40 pb-safe"
      style={{ paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 8px)', minHeight: '56px', background: 'var(--c-nav-bg)', borderColor: 'var(--c-nav-border)' }}
    >
      {navItems.map((item) => {
        const isActive = currentPage === item.id;
        return (
          <button
            key={item.id}
            data-testid={`nav-${item.id}-btn`}
            onClick={() => navigate(item.path)}
            className="flex items-center justify-center w-10 h-10 rounded-full transition-all active:scale-95"
            style={{ color: isActive ? (isLightMode ? '#191919' : '#7EA86C') : 'var(--c-nav-inactive)' }}
          >
            <Icon icon={isActive ? item.activeIcon : item.icon} width={22} />
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;